import { QueryClient, queryOptions, UseQueryOptions } from "@tanstack/react-query";
import { Build, Job } from "~/components/build/Show/lib/types";
import fetcher from "~/components/build/Show/lib/fetcher";

export const jobQueryKey = (build: Build, jobId: string) => {
  return ["build", build.id, "jobs", jobId];
};

export const jobQueryOptions = (
  build: Build,
  jobId: string,
  queryOptionsArgs: Omit<UseQueryOptions<Job>, "queryKey" | "queryFn"> = {},
) => {
  return queryOptions({
    queryKey: jobQueryKey(build, jobId),
    queryFn: ({ signal }) => fetchJob(build.buildDataBasePath, jobId, signal),
    ...queryOptionsArgs,
  });
};

export const setJobQueryData = (build: Build, job: Job, queryClient: QueryClient) => {
  queryClient.setQueryData(jobQueryKey(build, job.id), job);
};

export const fetchJob = (
  buildDataBasePath: Build["buildDataBasePath"],
  jobId: string,
  signal: AbortSignal,
) => {
  const url = new URL(`${buildDataBasePath}/jobs/${jobId}`, window.location.origin);

  return fetcher<Job>(url, true, { signal });
};
